import { render, staticRenderFns } from "./formLayout.vue?vue&type=template&id=50389b10&scoped=true"
import script from "./formLayout.vue?vue&type=script&lang=js"
export * from "./formLayout.vue?vue&type=script&lang=js"
import style0 from "./formLayout.vue?vue&type=style&index=0&id=50389b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50389b10",
  null
  
)

export default component.exports